<template>
    <f7-page name="Search">
        <f7-navbar inner-class="no-padding-search">
            <f7-searchbar
                custom-search
                @searchbar:search="onSearch"
                @searchbar:clear="onSearchClear"
                @searchbar:disable="onSearchClear"
            />
        </f7-navbar>
        <f7-list class="searchbar-not-found">
            <f7-list-item title="Nothing found" />
        </f7-list>
        <f7-list
            media-list
            class="search-list searchbar-found"
        >
            <f7-list-item
                v-for="(unit, index) in results"
                :key="`result-${index}`"
                :link="'#'"
                @click="onClick(unit)"
            >
                <div
                    slot="title"
                    v-html="unit._highlightResult.name.value"
                />
                <div
                    v-if="unit._snippetResult"
                    slot="subtitle"
                    v-html="unit._snippetResult.slides[0].text.value"
                />
                <div
                    slot="after"
                    class="afterSearch"
                    v-html="renderUnitType(unit.type)"
                />
            </f7-list-item>

        </f7-list>
    </f7-page>
</template>

<script>
import _ from 'lodash';

import utils from '../js/utils';

export default {
    store: ['api', 'user', 'unitsIndex', 'courseIndex', 'myTraits'],
    data () {
        return {
            query: '',
            results: [],
        };
    },
    computed: {
        isPgap: function () {
            return pgap;
        }
    },

    created: function () { },
    mounted: function () {
        setTimeout(() => {
            $$("input[type='search']").focus();
        }, 100);
    },
    beforeDestroy: function () { },
    methods: {
        renderUnitType: function (type) {
            return utils.renderUnitType(type);
        },
        onClick: function (unit) {
            let newUnit = this.unitsIndex[unit.id];
            if (unit.type === 'question') {
                this.goToInPopup(`/comments/${unit.id}`, newUnit);
            } if (unit.type === 'post') {
                if (pgap) {
                    cordova.InAppBrowser.open(`https://getcoral.app/journal/${unit.id}${unit.section}`, '_blank', 'location=no,presentationstyle=fullscreen,toolbarposition=top,toolbarcolor=#000000,closebuttoncolor=#fc6f65');
                } else {
                    window.open(`https://getcoral.app/journal/${unit.id}${unit.section}`);
                }
            } else {
                this.goToInPopup(`/units/${unit.id}`, newUnit);
            }
            if (newUnit.completed || newUnit.started) return;
            this.$events.fire('user-progress', {
                itemId: newUnit.isVersionOf || newUnit.id,
                courseId: 0,
                topicId: 0,
                type: 'unit',
                progress: 0,
                completed: false,
                item: newUnit
            });
            newUnit.started = true;
        },
        goToInPopup: function (url, unit) {
            if (unit.hasVersions) {
                for (let i = 0; i < unit.versions.length; i++) {
                    const v = unit.versions[i];
                    if (!v.published) continue;
                    if (v.isVersionOf) {
                        let validUnit = utils.checkTraits(this.myTraits, v);
                        if (validUnit && unit.type === 'question') {
                            url = `/comments/${v.id}`;
                        } else if (validUnit) {
                            url = `/units/${v.id}`;
                        }
                    }
                }
            }
            f7.views['popup'].router.navigate(url, {
                animate: false,
                clearPreviousHistory: true,
                ignoreCache: true
            });
            if (!pgap) window.history.pushState(null, "", '/web' + url);
            setTimeout(() => {
                f7.popup.get('#popup').open();
            }, 550);
        },
        onSearch: function (searchbar, query) {
            this.query = query;
            this.doSearch();
        },
        onSearchClear: function () {
            this.$f7.views['main'].router.back();
        },
        doSearch: _.debounce(function () {
            this.$events.fire('trackEvent', `search`, 'search', 0, '', {
                query: this.query
            });
            this.$http.get(`${this.api}/search?q=${this.query}`).then(
                (response) => {
                    this.results = response.body || [];
                },
                response => {
                    console.error(response.body);
                }
            );
        }, 300),
    }
};
</script>
<style lang="less">
@import '../css/colors.less';
.search-list em {
    color: @red;
    font-style: normal;
}
.no-padding-search {
    margin-top: 22px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
}
// .searchbar-enabled styles always
.ios .searchbar-disable-button {
    pointer-events: auto;
    opacity: 1;
    margin-left: 8px;
}
.ios .searchbar-disable-button {
    font-size: 17px;
    flex-shrink: 0;
    transform: translate3d(0, 0, 0);
    transition-duration: 300ms;
    color: var(--f7-searchbar-link-color, var(--f7-bars-link-color, var(--f7-theme-color)));
    display: inline-block;
}
.list.search-list ul {
    background: transparent;
}
</style>
<style lang="less" scoped>
@import '../css/colors.less';

.afterSearch {
    font-family: AndesMedium;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
}
</style>
